import { Component, OnInit } from '@angular/core';
import { IJobTitle } from './job-titles.types';
import { JobTitlesService } from './job-titles.service';
import { HttpErrorResponse } from '@angular/common/http';
import { Router } from '@angular/router';

@Component({
	selector: 'app-job-titles',
	templateUrl: './job-titles.component.html',
	styleUrls: ['./job-titles.component.scss']
})
export class JobTitlesComponent implements OnInit {
	constructor(private jobTitlesService: JobTitlesService, private router: Router) {}

	public jobTitles: IJobTitle[];
	public onlyArchived: boolean;

	ngOnInit(): void {
		this.getJobTitles();
	}

	public getJobTitles(): void {
		this.jobTitles = [];
		this.jobTitlesService.getJobTitles().subscribe(
			(DATA: IJobTitle[]) => {
				if (DATA) {
					this.jobTitles = DATA;
				}
			},
			(error: HttpErrorResponse) => {
				console.error(error);
			}
		);
	}

	public navigate(id: string): void {
		this.router.navigate(['/pilotpay/job-titles/details', id]);
	}

	public changeFilter(): void {
		if (this.onlyArchived) {
			this.getArchivedJobTitles();
		} else {
			this.getJobTitles();
		}
	}

	public getArchivedJobTitles(): void {
		this.jobTitles = [];
		this.jobTitlesService.getArchivedJobTitles().subscribe(
			(DATA: IJobTitle[]) => {
				if (DATA) {
					this.jobTitles = DATA;
				}
			},
			(error: HttpErrorResponse) => {
				console.error(error);
			}
		);
	}
}
